<template>
   <div id="left-sidebar" class="sidebar">
      <div class="">
        <div class="user-account">
            <!-- Avatar: show real photo if available, otherwise show initial with generated color -->
            <div v-if="authStore.user?.photo" class="rounded-circle user-photo">
                <img :src="authStore.user.photo" alt="User Profile Picture" style="width:100%;height:100%;border-radius:50%;object-fit:cover;" />
            </div>
            <div v-else :title="userName" class="user-photo initial-avatar" :style="{ backgroundColor: avatarColor }">
                {{ avatarInitial }}
            </div>
            <div class="dropdown" v-bind:class="{ 'show': dropActive}" @click="dropActive = !dropActive" v-click-outside="outside">
                <span>Benvenuto,</span>
                <a href="javascript:void(0);" class="dropdown-toggle user-name" data-toggle="dropdown" :aria-expanded="dropActive ? 'true' : 'false'">
                    <strong>{{ userName }}</strong>
                </a>
                <ul class="dropdown-menu dropdown-menu-right account" v-bind:class="{ 'show': dropActive }">
                    <li v-if="isClientUser">
                        <router-link to="/cliente/profilo" @click.native="dropActive = false">
                            <i class="icon-user"></i>Il mio Profilo
                        </router-link>
                    </li>
                    <li><a href="javascript:void(0);" @click="handleLogout"><i class="icon-power"></i>Logout</a></li>
                </ul>
            </div>
        </div> 
          
        <!-- Nav tabs -->
        <ul class="nav nav-tabs">
            <li class="nav-item"><a class="nav-link active show" data-toggle="tab">Menu</a></li>
        </ul>  
          
        <!-- Tab panes -->
        <div class="tab-content p-l-0 p-r-0">
            <div class="tab-pane active show" id="menu">
                <nav id="left-sidebar-nav" class="sidebar-nav">
                    <ul id="main-menu" class="metismenu">
                        <!-- 🏠 DASHBOARD -->
                        <li v-if="isAdminUser" v-bind:class="{ 'active': currentActiveMenu == 'dashboard' }">
                            <a class="has-arrow" v-on:click="setActive('dashboard')">
                                <i class="icon-home"></i> <span>Dashboard</span>
                            </a>
                            <ul v-if="currentActiveMenu === 'dashboard'">
                                <li v-bind:class="{ 'active':currentRoutePath == '/dashboard/index'}">
                                    <router-link to="/dashboard/index">Panoramica</router-link>
                                </li>   
                            </ul>
                        </li>
                        <!-- 📚 API DOCUMENTATION (admin, superadmin, tecnico) -->
                        <li v-if="isAdminOrTech" :class="{ 'active': currentActiveMenu === 'api' }">
                            <a class="has-arrow" v-on:click="setActive('api')">
                                <i class="icon-docs"></i> <span>API Docs</span>
                            </a>
                            <ul v-if="currentActiveMenu === 'api'">
                                <li :class="{ 'active': currentRoutePath == '/admin/technical-docs' }">
                                    <router-link to="/admin/technical-docs">Documentazione Tecnica</router-link>
                                </li>
                                <!-- Gestione documentazione rimossa come richiesto -->
                            </ul>
                        </li>
                        
                        <!-- 👥 GESTIONE UTENTI -->
                        <li v-if="isAdminUser" :class="{ 'active': currentActiveMenu === 'users' }">
                            <a class="has-arrow" v-on:click="setActive('users')">
                                <i class="icon-users"></i> <span>Gestione Utenti</span>
                            </a>
                            <ul v-if="currentActiveMenu === 'users'">
                                <li :class="{ 'active': currentRoutePath == '/admin/users' }">
                                    <router-link to="/admin/users">Utenti</router-link>
                                </li>
                                <li :class="{ 'active': currentRoutePath == '/admin/permissions' }">
                                    <router-link to="/admin/permissions">Permessi</router-link>
                                </li>
                                <li :class="{ 'active': currentRoutePath == '/admin/audit' }">
                                    <router-link to="/admin/audit">Audit Log</router-link>
                                </li>
                            </ul>
                        </li>
                        
                        <!-- 📋 ANAGRAFICHE E CONTRATTI -->
                        <li v-if="isAdminUser" :class="{ 'active': currentActiveMenu === 'anagrafiche'}">
                            <a class="has-arrow" v-on:click="setActive('anagrafiche')">
                                <i class="icon-user"></i> <span>Anagrafiche e Contratti</span>
                            </a>
                            <ul v-if="currentActiveMenu === 'anagrafiche'">
                                <li v-bind:class="{ 'active':currentRoutePath == '/anagrafiche/list'}">
                                    <router-link to="/anagrafiche/list">Clienti</router-link>
                                </li>
                                <li v-bind:class="{ 'active':currentRoutePath == '/contratti/list'}">
                                    <router-link to="/contratti/list">Contratti</router-link>
                                </li>
                                <li v-bind:class="{ 'active':currentRoutePath == '/contratti/templates'}">
                                    <router-link to="/contratti/templates">Template Contratti</router-link>
                                </li>
                                <li v-bind:class="{ 'active':currentRoutePath == '/contratti/assign'}">
                                    <router-link to="/contratti/assign">Assegna Contratti</router-link>
                                </li>
                            </ul>
                        </li>

                        <!-- 🔧 LAVORAZIONI E ASSISTENZA -->
                        <li v-if="isAdminUser" :class="{ 'active': currentActiveMenu === 'lavorazioni'}">
                            <a class="has-arrow" v-on:click="setActive('lavorazioni')">
                                <i class="icon-wrench"></i> <span>Lavorazioni e Assistenza</span>
                            </a>
                            <ul v-if="currentActiveMenu === 'lavorazioni'">
                                <li v-bind:class="{ 'active':currentRoutePath == '/lavorazioni/list'}">
                                    <router-link to="/lavorazioni/list">Le Mie Lavorazioni</router-link>
                                </li>
                                <li v-bind:class="{ 'active':currentRoutePath == '/assistenza/list'}">
                                    <router-link to="/assistenza/list">Storico Interventi</router-link>
                                </li>
                                <li v-bind:class="{ 'active':currentRoutePath == '/assistenza/interna'}">
                                    <router-link to="/assistenza/interna">Assistenza Interna</router-link>
                                </li>
                            </ul>
                        </li>

                        <!-- 🎟️ TICKET E SUPPORTO -->
                        <li v-if="isAdminUser" :class="{ 'active': currentActiveMenu === 'ticket'}">
                            <a class="has-arrow" v-on:click="setActive('ticket')">
                                <i class="icon-support"></i> <span>Ticket e Supporto</span>
                            </a>
                            <ul v-if="currentActiveMenu === 'ticket'">
                                <li v-bind:class="{ 'active': currentRoutePath == '/tickets/list' }">
                                    <router-link to="/tickets/list">Gestione Ticket</router-link>
                                </li>
                                <li v-bind:class="{ 'active': currentRoutePath == '/tickets/new' }">
                                    <router-link to="/tickets/new">Nuovo Ticket</router-link>
                                </li>
                                <li v-bind:class="{ 'active': currentRoutePath == '/tickets/attachments' }">
                                    <router-link to="/tickets/attachments">Allegati</router-link>
                                </li>
                                <li v-bind:class="{ 'active': currentRoutePath == '/tickets/timers' }">
                                    <router-link to="/tickets/timers">Timer</router-link>
                                </li>
                                <li v-bind:class="{ 'active': currentRoutePath == '/tickets/sla' }">
                                    <router-link to="/tickets/sla">SLA</router-link>
                                </li>
                            </ul>
                        </li>

                        <!-- 💻 CONFIGURAZIONE -->
                        <li v-if="isAdminUser" :class="{ 'active': currentActiveMenu === 'configurazione'}">
                            <a class="has-arrow" v-on:click="setActive('configurazione')">
                                <i class="icon-screen-desktop"></i> <span>Configurazione</span>
                            </a>
                            <ul v-if="currentActiveMenu === 'configurazione'">
                                <li v-bind:class="{ 'active':currentRoutePath == '/dispositivi/list'}">
                                    <router-link to="/dispositivi/list">Dispositivi</router-link>
                                </li>
                                <li v-bind:class="{ 'active': currentRoutePath == '/fornitori' }">
                                    <router-link to="/fornitori">Fornitori</router-link>
                                </li>

                                <li v-bind:class="{ 'active': currentRoutePath == '/providers' }">
                                    <router-link to="/providers">Provider</router-link>
                                </li>
                            </ul>
                        </li>

                        <!-- � SCADENZIARIO -->
                        <li v-if="isAdminUser" :class="{ 'active': currentActiveMenu === 'scadenziario'}">
                            <a class="has-arrow" v-on:click="setActive('scadenziario')">
                                <i class="icon-list"></i> <span>Scadenziario</span>
                            </a>
                            <ul v-if="currentActiveMenu === 'scadenziario'">
                                <li v-bind:class="{ 'active': currentRoutePath == '/services'}">
                                    <router-link to="/services">Lista Scadenziario</router-link>
                                </li>
                                <li v-bind:class="{ 'active': currentRoutePath == '/services/create'}">
                                    <router-link to="/services/create">Nuovo Servizio</router-link>
                                </li>
                                <li v-bind:class="{ 'active': currentRoutePath == '/service-templates'}">
                                    <router-link to="/service-templates">Template Servizi</router-link>
                                </li>
                                <li v-bind:class="{ 'active': currentRoutePath == '/providers' || currentRoutePath == '/fornitori'}">
                                    <router-link to="/providers">Provider</router-link>
                                </li>
                                <li v-bind:class="{ 'active': currentRoutePath == '/service-categories'}">
                                    <router-link to="/service-categories">Categorie</router-link>
                                </li>
                            </ul>
                        </li>

                        <!-- �📊 REPORTISTICA E DATI -->
                        <li v-if="isAdminUser" :class="{ 'active': currentActiveMenu === 'report'}">
                            <a class="has-arrow" v-on:click="setActive('report')">
                                <i class="icon-chart"></i> <span>Reportistica e Dati</span>
                            </a>
                            <ul v-if="currentActiveMenu === 'report'">
                                <li v-bind:class="{ 'active': currentRoutePath == '/admin/report' }">
                                    <router-link to="/admin/report">KPI e Report</router-link>
                                </li>
                                <li v-bind:class="{ 'active':currentRoutePath == '/charts/chart-echarts'}">
                                    <router-link to="/charts/chart-echarts">Statistiche</router-link>
                                </li>
                                <li v-bind:class="{ 'active':currentRoutePath == '/widgets/widgets-data'}">
                                    <router-link to="/widgets/widgets-data">Widget Dati</router-link>
                                </li>
                            </ul>
                        </li>

                        <!-- 📅 CALENDARIO E DOCUMENTI -->
                        <li v-if="isAdminUser" :class="{ 'active': currentActiveMenu === 'calendario'}">
                            <a class="has-arrow" v-on:click="setActive('calendario')">
                                <i class="icon-calendar"></i> <span>Calendario e Documenti</span>
                            </a>
                            <ul v-if="currentActiveMenu === 'calendario'">
                                <li v-bind:class="{ 'active': currentRoutePath == '/admin/calendar' }">
                                    <router-link to="/admin/calendar">Scadenze e Attività</router-link>
                                </li>
                                <li v-bind:class="{ 'active':currentRoutePath == '/app/app-calendar'}">
                                    <router-link to="/app/app-calendar">Appuntamenti</router-link>
                                </li>
                                <li v-bind:class="{ 'active':currentRoutePath == '/pages/page-timeline'}">
                                    <router-link to="/pages/page-timeline">Timeline</router-link>
                                </li>
                                <li v-bind:class="{ 'active':currentRoutePath == '/file-manager/file-documents'}">
                                    <router-link to="/file-manager/file-documents">Archivio Documenti</router-link>
                                </li>
                            </ul>
                        </li>

                        <!-- 💬 COMUNICAZIONI -->
                        <li v-if="isAdminUser" :class="{ 'active': currentActiveMenu === 'comunicazioni'}">
                            <a class="has-arrow" v-on:click="setActive('comunicazioni')">
                                <i class="icon-bubble"></i> <span>Comunicazioni</span>
                            </a>
                            <ul v-if="currentActiveMenu === 'comunicazioni'">
                                <li v-bind:class="{ 'active':currentRoutePath == '/app/app-inbox'}">
                                    <router-link to="/app/app-inbox">Email</router-link>
                                </li>
                                <li v-bind:class="{ 'active':currentRoutePath == '/app/app-chat'}">
                                    <router-link to="/app/app-chat">Chat</router-link>
                                </li>
                            </ul>
                        </li>

                        <!-- ⚙️ IMPOSTAZIONI -->
                        <li v-if="isAdminUser" :class="{ 'active': currentActiveMenu === 'impostazioni'}">
                            <a class="has-arrow" v-on:click="setActive('impostazioni')">
                                <i class="icon-settings"></i> <span>Impostazioni</span>
                            </a>
                            <ul v-if="currentActiveMenu === 'impostazioni'">
                                <li v-bind:class="{ 'active': currentRoutePath == '/admin/settings' }">
                                    <router-link to="/admin/settings">Impostazioni Generali</router-link>
                                </li>
                                <li v-bind:class="{ 'active':currentRoutePath == '/pages/page-faq'}">
                                    <router-link to="/pages/page-faq">FAQ</router-link>
                                </li>
                            </ul>
                        </li>

<!-- PORTALE CLIENTE -->
                        <!-- Portale Cliente -->
                        <li v-if="isClientUser" :class="{ 'active': currentActiveMenu === 'cliente'}">
                            <a class="has-arrow" v-on:click="setActive('cliente')">
                                <i class="icon-user-follow"></i> <span>Portale Cliente</span>
                            </a>
                            <ul v-if="currentActiveMenu === 'cliente'">
                                <li v-bind:class="{ 'active': currentRoutePath == '/cliente/dashboard' }">
                                    <router-link to="/cliente/dashboard">Dashboard</router-link>
                                </li>
                                <li v-bind:class="{ 'active': currentRoutePath == '/cliente/notifiche' }">
                                    <router-link to="/cliente/notifiche">Notifiche</router-link>
                                </li>
                                <li v-bind:class="{ 'active': currentRoutePath == '/cliente/supporto' }">
                                    <router-link to="/cliente/supporto">Supporto diretto</router-link>
                                </li>
                                <li v-bind:class="{ 'active': currentRoutePath == '/cliente/anagrafica' || currentRoutePath == '/cliente/profilo' }">
                                    <router-link to="/cliente/anagrafica">Anagrafica</router-link>
                                </li>
                                <li v-bind:class="{ 'active': currentRoutePath == '/cliente/lavorazioni' || currentRoutePath.startsWith('/cliente/lavorazioni/') }">
                                    <router-link to="/cliente/lavorazioni">Lavorazioni</router-link>
                                </li>
                                <li v-bind:class="{ 'active': currentRoutePath == '/cliente/interventi' }">
                                    <router-link to="/cliente/interventi">Interventi</router-link>
                                </li>
                                <li v-bind:class="{ 'active': currentRoutePath == '/cliente/rapportini' }">
                                    <router-link to="/cliente/rapportini">Rapportini</router-link>
                                </li>
                                <li v-bind:class="{ 'active': currentRoutePath == '/cliente/documenti' }">
                                    <router-link to="/cliente/documenti">Documenti</router-link>
                                </li>
                                <li v-bind:class="{ 'active': currentRoutePath == '/cliente/ore-residue' }">
                                    <router-link to="/cliente/ore-residue">Ore Residue</router-link>
                                </li>
                                <li v-bind:class="{ 'active': currentRoutePath == '/cliente/ticket' }">
                                    <router-link to="/cliente/ticket">Ticket</router-link>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </nav>

                <div v-if="isAdminUser" class="sidebar-funding-box">
                    <p class="sidebar-funding-text">
                        Il progetto ByteRivo è realizzato grazie ai Fondi europei della Regione Umbria.
                    </p>
                    <router-link to="/progetto-finanziato" class="sidebar-funding-link">
                        Dettaglio progetto finanziato
                    </router-link>
                    <img
                        src="/loghi/Coesione%20UE%20ITA%20estesa_colori_v1.svg"
                        alt="Loghi Programma Regionale FESR 2021-2027 Regione Umbria e Unione Europea"
                        class="sidebar-funding-logo"
                    />
                </div>
            </div>
        </div>
      </div>
   </div>
</template>

<script>
import { useAuthStore } from '@/stores/auth';

export default {
    name: 'SidebarComponent',
    data() {
        return {
            currentActiveMenu: 'dashboard',
            dropActive: false,
            activeColor: 'blue',
            data_theme: ''
        };
    },
    setup() {
        const authStore = useAuthStore();
        return { authStore };
    },
    computed: {
        currentRoutePath() {
            return this.$route.path;
        },
        userName() {
            return this.authStore.user?.email || 'Utente';
        },
        avatarInitial() {
            const u = this.authStore.user;
            const name = (u && (u.name || u.fullname || u.first_name || u.email)) || 'U';
            return String(name).trim().charAt(0).toUpperCase();
        },
        avatarColor() {
            const u = this.authStore.user;
            const name = (u && (u.name || u.fullname || u.first_name || u.email)) || 'Utente';
            return this.colorFromString(String(name));
        },
        isAdminUser() {
            return this.authStore.hasPermission('admin.access');
        },
        isClientUser() {
            return this.authStore.userRoles.includes('cliente');
        },
        isAdminOrTech() {
            const roles = this.authStore.userRoles || [];
            return this.authStore.hasPermission('admin.access') || roles.includes('superadmin') || roles.includes('tecnico');
        },
    },
    methods: {
        setActive(menu) {
            this.currentActiveMenu = this.currentActiveMenu === menu ? '' : menu;
        },
        outside() {
            this.dropActive = false;
        },
        async handleLogout() {
            await this.authStore.logout();
            this.$toast.success('Logout effettuato');
            this.$router.push('/authentication/page-login');
        },
        colorFromString(str) {
            let hash = 0;
            for (let i = 0; i < str.length; i++) {
                hash = str.charCodeAt(i) + ((hash << 5) - hash);
            }
            const hue = Math.abs(hash) % 360;
            return `hsl(${hue}, 65%, 45%)`;
        },
        mountedApplyTheme() {
            try{
                const storedTheme = localStorage.getItem('byterivo:theme') || '';
                const storedColor = localStorage.getItem('byterivo:color') || this.activeColor;
                this.data_theme = storedTheme;
                this.activeColor = storedColor;
                document.body.className = 'theme-'+this.activeColor +' '+ this.data_theme;
            }catch(e){ console.warn(e); }
        }
    },
    directives: {
        'click-outside': {
            mounted(el, binding) {
                el.clickOutsideEvent = function(event) {
                    if (!(el === event.target || el.contains(event.target))) {
                        binding.value();
                    }
                };
                document.body.addEventListener('click', el.clickOutsideEvent);
            },
            unmounted(el) {
                document.body.removeEventListener('click', el.clickOutsideEvent);
            },
        },
    },
    mounted(){
        this.mountedApplyTheme && this.mountedApplyTheme();
    },
};
</script>

<style scoped>
/* Initial-letter avatar styles */
.initial-avatar{
    width: 50px;
    height: 50px;
    display: inline-block;
    border-radius: 50%;
    text-align: center;
    line-height: 46px;
    font-weight: 600;
    font-size: 18px;
    color: #ffffff;
    box-sizing: border-box;
    border: 2px solid rgba(0,0,0,0.08);
    margin-right: 10px;
    vertical-align: top;
}

.sidebar-funding-box {
    margin: 14px 14px 18px;
    padding: 12px;
    border-radius: 10px;
    border: 1px solid rgba(140, 155, 174, 0.25);
    background: rgba(255, 255, 255, 0.82);
}

.sidebar-funding-text {
    margin: 0 0 8px;
    font-size: 12px;
    line-height: 1.45;
    color: #2f3c4d;
}

.sidebar-funding-link {
    display: inline-block;
    margin: 0 0 10px;
    color: #1c4b80;
    text-decoration: underline;
    font-weight: 600;
    font-size: 12px;
}

.sidebar-funding-logo {
    display: block;
    width: 100%;
    height: auto;
    background: #ffffff;
    border-radius: 8px;
    padding: 8px;
    border: 1px solid #d9e2ec;
}
</style>
